import BrowserSupport from './assets/browser-support.js';
BrowserSupport.isIE10();

import Vue from 'vue';
import App from './App.vue';
import Questionnaire from '@/components/Questionnaire.vue';
import Result from '@/components/Result.vue';
import Index from '@/components/Index.vue';
import VueRouter from 'vue-router';
import linkify from 'vue-linkify';
import VueGtag from 'vue-gtag';
import './styles/app.scss';
import './styles/typography.scss';
import '@cityofphiladelphia/phila-app-css/dist/css/phila-app.min.css';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.directive('linkified', linkify);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Index,
    },
    {
      path: '/questionnaire',
      name: 'Questionnaire',
      component: Questionnaire,
    },
    {
      path: '/result/:code',
      name: 'Result',
      component: Result,
      props: true,
    },
  ],
});

Vue.use(VueGtag, {
  config:{
    id: 'UA-860026-1',
    appName: 'employee-screener',
    pageTrackerScreenviewEnabled: true,
    params: {},
  },
}, router);

new Vue({
  el: '#vue-app',
  router,
  render (h) {
    return h(App, {});
  },
});
